import { useEffect } from "react";
import { useSelector } from "react-redux";

export default function ChamUpload() {

    useEffect(() => {
        document.querySelector("im-upload").addEventListener("upload", function () {
            if(document.getElementById("imgInp").value !== ""){
                document.querySelector("dialog").showModal();
            } 
          });
          
          document.getElementById('imgToUpload').addEventListener('load', function(){ // Goes straight to visualizer
            document.querySelector('#upload-section .btn-upload').click();
          });
    

    }, []);

    return(
        <im-upload title="Upload My Own Photo" calltoaction="Start Your Project" active="0" postpage="IM.aspx"></im-upload>
    );
}

export function ChamUploadButton({className, title, onClick}) {
    const activePattern = useSelector(state => state.visualizer.activePattern);
    const selectedSlotProducts = useSelector(state => state.visualizer.selectedSlotProducts);

    const handleClick = function() {
        // Generate selection string: activePatternId(productId1,productId2,productId3)
        if (activePattern) {
            const patternId = activePattern.id || activePattern.patternId || '';
            
            // Get selected product IDs
            const productIds = [];
            if (activePattern.descriptor) {
                const colorSlots = activePattern.descriptor.split(',').map(slot => slot.trim());
                colorSlots.forEach((_, index) => {
                    const product = selectedSlotProducts[index];
                    if (product && product.id) {
                        productIds.push(product.id);
                    } else {
                        productIds.push('-1');
                    }
                });
            }
            
            // Create selection string in format: patternId(product1,product2,product3)
            const selectionString = `${patternId}(${productIds.join(',')})`;
            
            // Save to localStorage
            localStorage.setItem('CURRENT_SELECTION', selectionString);
            
            console.log('Saved current_selection to localStorage:', selectionString);
        } else {
            console.warn('No active pattern available to save');
        }
        
        // Call the optional onClick callback (e.g., to close menu)
        if (onClick) {
            onClick();
        }
        
        // Trigger the upload button
        document.querySelector(".uploaderBTN").click();
    }

    return(
        <button onClick={handleClick} className={className}>{title}</button>
    )
}